module.exports = __webpack_public_path__ + "img/MC2.b10af192.webp";